"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExplicitContent = exports.Likelihood = void 0;
var Likelihood;
(function (Likelihood) {
    Likelihood["VERY_LIKELY"] = "VERY_LIKELY";
    Likelihood["POSSIBLE"] = "POSSIBLE";
    Likelihood["UNLIKELY"] = "UNLIKELY";
    Likelihood["VERY_UNLIKELY"] = "VERY_UNLIKELY";
})(Likelihood = exports.Likelihood || (exports.Likelihood = {}));
var ExplicitContent = /** @class */ (function () {
    function ExplicitContent(data) {
        this.likelihood = data.likelihood;
        this.name = data.name;
    }
    return ExplicitContent;
}());
exports.ExplicitContent = ExplicitContent;
//# sourceMappingURL=explicit-content.js.map